<template>
  <div id="info" class="pl-6 pr-6 pt-0 pb-4 rounded-3 text-black">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
